import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VEHICLES_PATH } from '../shared/constants';
import { VehiclesComponent } from './vehicles.component';

const routes: Routes = [
  {
    path: VEHICLES_PATH,
    component: VehiclesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VehiclesRoutingModule { }
